// Las descargas del onboarding de marca (ADR-2026-10-05-onboarding-v2-descarga-abre-planes).
//
// Lo mismo que hacía la pantalla de resultados del cuestionario viejo: si la persona se lleva
// alguna de sus primeras piezas, al salir del onboarding ve el catálogo de planes
// (`abreElCatalogoDePlanes`, ADR-2026-07-29-upsell-planes-salir-alta-condicionado). La marca va al
// navegador (decide el catálogo y sobrevive a un refresh) y a la empresa (para medirlo).

import { SETUP_DOWNLOADED_KEY } from '../../components/onboarding/accountSetup';
import { marcarDescargaDelOnboarding } from '../onboardingTracking';

let marcadaEnLaEmpresa = false;

/** Se llevó una pieza. Llamarla SÓLO si la descarga salió bien de verdad. */
export function registrarDescarga(): void {
  try {
    localStorage.setItem(SETUP_DOWNLOADED_KEY, '1');
  } catch {
    /* sin storage, el catálogo no se entera; la descarga igual salió */
  }
  if (!marcadaEnLaEmpresa) {
    marcadaEnLaEmpresa = true;
    marcarDescargaDelOnboarding();
  }
}

/** ¿Ya se llevó alguna pieza en este navegador? */
export function yaDescargo(): boolean {
  try {
    return localStorage.getItem(SETUP_DOWNLOADED_KEY) === '1';
  } catch {
    return false;
  }
}
